export const SIM_PROVENIENZE = ["Iliad", "CoopVoce", "Poste", "WindTre", "Very", "TIM", "Kena", "Vodafone", "Ho", "Fastweb", "Lyca", "Digi", "Altro"];
export const WT_CATEGORIE_FISSO = ["FWA Outdoor", "FTTH", "FWA Indoor 2P", "Voce Casa", "FTTC", "Seconda Linea P.IVA"];
export const WT_ESITI = [
  { id: "riconosciuta", label: "Riconosciuta" },
  { id: "in_attesa", label: "In attesa di riconoscimento" },
  { id: "annullata", label: "Annullata" },
  { id: "respinta", label: "Respinta" },
  { id: "non_riconosciuta", label: "Non riconosciuta" },
  { id: "stornata", label: "Stornata" },
];


export const LAVORAZIONI = [
  { id: "cambiare", label: "Da Cambiare", badge: "bg-amber-500/15 text-amber-700 border-amber-300" },
  { id: "non_cambiare", label: "Non Cambiare", badge: "bg-slate-500/15 text-slate-700 border-slate-300" },
  { id: "cambio_effettuato", label: "Cambio Effettuato", badge: "bg-emerald-500/15 text-emerald-700 border-emerald-300" },
  { id: "in_quotazione", label: "In Quotazione", badge: "bg-sky-500/15 text-sky-700 border-sky-300" },
  { id: "richieste_bollette", label: "Richieste Bollette", badge: "bg-violet-500/15 text-violet-700 border-violet-300" },
  { id: "in_attesa_ok", label: "In Attesa OK Cliente", badge: "bg-indigo-500/15 text-indigo-700 border-indigo-300" },
  { id: "problema_tecnico", label: "Problema Tecnico", badge: "bg-rose-500/15 text-rose-700 border-rose-300" },
  { id: "da_quotare", label: "Da Quotare", badge: "bg-cyan-500/15 text-cyan-700 border-cyan-300" },
  { id: "contattare_cliente", label: "Contattare Cliente", badge: "bg-yellow-500/15 text-yellow-700 border-yellow-300" },
  { id: "non_vuole_cambiare", label: "Non Vuole Cambiare", badge: "bg-zinc-500/15 text-zinc-700 border-zinc-300" },
  { id: "passa_in_negozio", label: "Passa in Negozio", badge: "bg-teal-500/15 text-teal-700 border-teal-300" },
  { id: "attesa_documenti", label: "Attesa Documenti", badge: "bg-orange-500/15 text-orange-700 border-orange-300" },
  { id: "rinnovato", label: "Rinnovato", badge: "bg-green-600/15 text-green-800 border-green-300" },
  { id: "annullato", label: "Annullato (da reinserire)", badge: "bg-red-600/15 text-red-800 border-red-300" },
];

export const lavorazioneLabel = (id) =>
  LAVORAZIONI.find((l) => l.id === id)?.label || id || "-";

export const lavorazioneBadge = (id) =>
  LAVORAZIONI.find((l) => l.id === id)?.badge || "bg-slate-500/15 text-slate-700 border-slate-300";

export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d;
  }
};

export const RUOLI = { admin: "Amministratore", operatore: "Operatore", negozio: "Negozio", tecnico: "Tecnico" };

export const SECTIONS = [
  { id: "energia", label: "Energia" },
  { id: "riparazioni", label: "Riparazioni" },
  { id: "telefonia", label: "Telefonia" },
];

export const RIP_STATI = [
  { id: "ingresso", label: "Ingresso", badge: "bg-sky-500/15 text-sky-700 border-sky-300" },
  { id: "attesa_ricambio_cliente", label: "Attesa ricambio (disp. col cliente)", badge: "bg-amber-500/15 text-amber-700 border-amber-300" },
  { id: "attesa_ricambio_carico", label: "Attesa ricambio (disp. in carico)", badge: "bg-orange-500/15 text-orange-700 border-orange-300" },
  { id: "ricambio_arrivato", label: "Ricambio arrivato (cliente avvisato)", badge: "bg-lime-500/15 text-lime-700 border-lime-300" },
  { id: "in_attesa_cliente", label: "In attesa cliente", badge: "bg-yellow-500/15 text-yellow-700 border-yellow-300" },
  { id: "preventivo", label: "Preventivo", badge: "bg-violet-500/15 text-violet-700 border-violet-300" },
  { id: "in_lavorazione", label: "In lavorazione", badge: "bg-cyan-500/15 text-cyan-700 border-cyan-300" },
  { id: "pronto", label: "Pronto (in laboratorio)", badge: "bg-emerald-500/15 text-emerald-700 border-emerald-300" },
  { id: "pronto_ritiro", label: "Pronto da ritirare (in negozio)", badge: "bg-teal-500/15 text-teal-700 border-teal-300" },
  { id: "consegnato", label: "Consegnato", badge: "bg-green-600/15 text-green-800 border-green-300" },
  { id: "non_riparabile", label: "Non riparabile", badge: "bg-rose-500/15 text-rose-700 border-rose-300" },
];

export const ripStatoLabel = (id) => RIP_STATI.find((s) => s.id === id)?.label || id || "-";
export const ripStatoBadge = (id) => RIP_STATI.find((s) => s.id === id)?.badge || "bg-slate-500/15 text-slate-700 border-slate-300";
const TEL_STATI = { attivo: "Attivo", attiva: "Attiva", in_attesa: "In attesa attivazione", annullato: "Annullato", "": "Inserito" };
export const statoServizioLabel = (s) => {
  if (!s) return "-";
  if (s.tipo === "riparazione") return `Riparazione: ${ripStatoLabel(s.stato)}`;
  if (["sim", "internet", "fisso"].includes(s.tipo)) return `${s.tipo === "sim" ? "SIM" : s.tipo === "internet" ? "Internet" : "Fisso"}: ${TEL_STATI[s.stato] ?? s.stato}`;
  if (s.tipo === "ritiro") return `Ritiro usato${s.articolo ? ` ${s.articolo}` : ""}${s.numero ? ` · bolla ${s.numero}` : ""}: ${s.stato === "firmata" ? "firmato" : "da firmare"}`;
  if (s.tipo === "vendita_ordine") return `Vendita${s.articolo ? ` ${s.articolo}` : ""}: ${venditaStatoLabel(s.stato)}${s.stato === "consegnato" && s.pagato === false ? " (da pagare)" : ""}`;
  return s.tipo === "vendita" || s.tipo === "accessori" ? "Vendita effettuata" : s.tipo;
};
export const statoServizioBadge = (s) => (s?.tipo === "riparazione" ? ripStatoBadge(s.stato)
  : s?.tipo === "ritiro" ? (s.stato === "firmata" ? "bg-teal-500/15 text-teal-700 border-teal-300" : "bg-amber-500/15 text-amber-700 border-amber-300")
  : s?.tipo === "vendita_ordine" ? (s.stato === "ordinato" ? "bg-amber-500/15 text-amber-700 border-amber-300" : s.stato === "arrivato" ? "bg-sky-500/15 text-sky-700 border-sky-300" : s.pagato === false ? "bg-rose-500/15 text-rose-700 border-rose-300" : "bg-emerald-500/15 text-emerald-700 border-emerald-300")
  : "bg-indigo-500/15 text-indigo-700 border-indigo-300");


export const SERVIZIO_TIPI = [
  { id: "riparazione", label: "Riparazione", section: "riparazioni" },
  { id: "accessori", label: "Accessori", section: "telefonia" },
  { id: "vendita", label: "Vendita", section: "telefonia" },
  { id: "sim", label: "Mobile (SIM)", section: "telefonia" },
  { id: "internet", label: "Fisso / Internet", section: "telefonia" },
  { id: "fisso", label: "Fisso (voce)", section: "telefonia" },
];

export const servizioTipoLabel = (id) => SERVIZIO_TIPI.find((t) => t.id === id)?.label || id || "-";

export const SIM_ATTIVAZIONI = [
  { id: "nuovo", label: "Numero nuovo" },
  { id: "mnp", label: "Portabilità (MNP)" },
  { id: "cambio_offerta", label: "Cambio offerta / ricarica" },
];
export const RIP_ESITI = [
  { id: "normale", label: "Riparazione normale" },
  { id: "garanzia", label: "In garanzia" },
  { id: "ricambio_usato", label: "Con ricambio usato" },
  { id: "scheda_madre", label: "Scheda madre" },
  { id: "non_riparabile", label: "Non riparabile" },
  { id: "preventivo_rifiutato", label: "Preventivo non accettato" },
];
export const ripEsitoLabel = (id) => RIP_ESITI.find((s) => s.id === id)?.label || "";

export const TEL_OPERATORS = {
  sim: ["WINDTRE", "VERY", "TIM", "KENA", "FASTWEB", "HO", "ILIAD", "LYCA", "DIGI", "ENEL"],
  internet: ["EOLO", "WINDTRE", "FASTWEB", "ILIAD", "ENEL"],
  fisso: ["EOLO", "WINDTRE", "FASTWEB", "ILIAD", "ENEL"],
};


export const SBLOCCO_TIPI = [
  { id: "nessuno", label: "Nessun blocco" },
  { id: "simbolo", label: "Simbolo (sequenza)" },
  { id: "pin", label: "PIN numerico" },
  { id: "password", label: "Password" },
];

export const MAGAZZINO_CATEGORIE = [
  { id: "display", label: "Display" },
  { id: "ricambi", label: "Ricambi" },
  { id: "accessori", label: "Accessori" },
  { id: "sim", label: "SIM" },
  { id: "rigenerati", label: "Rigenerati / Usati" },
  { id: "altro", label: "Altro" },
];

export const RICAMBIO_TIPOLOGIE = [
  { id: "display", label: "Display" },
  { id: "batteria", label: "Batteria" },
  { id: "fotocamera", label: "Fotocamera" },
  { id: "connettore_ricarica", label: "Connettore ricarica" },
  { id: "vetro_posteriore", label: "Vetro posteriore" },
  { id: "altoparlante", label: "Altoparlante" },
  { id: "microfono", label: "Microfono" },
  { id: "tasti_flex", label: "Tasti / Flex" },
  { id: "scocca", label: "Scocca" },
  { id: "accessorio", label: "Accessorio" },
  { id: "altro", label: "Altro" },
];
export const tipologiaLabel = (id) => RICAMBIO_TIPOLOGIE.find((t) => t.id === id)?.label || id || "";

export const magazzinoCategoriaLabel = (id) =>
  MAGAZZINO_CATEGORIE.find((c) => c.id === id)?.label || id || "-";
export const VENDITE_CATEGORIE = [
  { id: "telefono_nuovo", label: "Telefono nuovo" },
  { id: "telefono_rigenerato", label: "Telefono rigenerato" },
  { id: "telefono_ricondizionato", label: "Telefono ricondizionato" },
  { id: "telefono_usato", label: "Telefono usato (ritiri)" },
  { id: "pc", label: "PC" },
  { id: "router", label: "Router" },
  { id: "accessori", label: "Accessori" },
  { id: "stampanti", label: "Stampanti" },
  { id: "altro", label: "Altro" },
];
export const venditaCategoriaLabel = (id) => VENDITE_CATEGORIE.find((c) => c.id === id)?.label || id || "-";
export const isCategoriaUsato = (id) => id === "telefono_rigenerato" || id === "telefono_usato" || id === "telefono_ricondizionato";
export const ivaDefaultPerCategoria = (id) => (id === "telefono_usato" ? "art36" : "iva22");
export const VENDITA_STATI = [
  { id: "ordinato", label: "Ordinato", badge: "bg-amber-500/15 text-amber-700 border-amber-300" },
  { id: "arrivato", label: "In attesa di ritiro", badge: "bg-sky-500/15 text-sky-700 border-sky-300" },
  { id: "consegnato", label: "Ritirato", badge: "bg-emerald-500/15 text-emerald-700 border-emerald-300" },
];
export const venditaStatoLabel = (id) => VENDITA_STATI.find((s) => s.id === (id || "consegnato"))?.label || id;
export const venditaStatoBadge = (id) => VENDITA_STATI.find((s) => s.id === (id || "consegnato"))?.badge || "";
export const REGIMI_IVA = [
  { id: "iva22", label: "IVA 22%", badge: "bg-slate-500/10 text-slate-700 border-slate-300" },
  { id: "art36", label: "Art. 36 (margine)", badge: "bg-orange-500/15 text-orange-700 border-orange-300" },
  { id: "art17", label: "Art. 17", badge: "bg-sky-500/15 text-sky-700 border-sky-300" },
];
export const regimeIvaLabel = (id) => REGIMI_IVA.find((r) => r.id === id)?.label || (id ? id : "-");
export const regimeIvaBadge = (id) => REGIMI_IVA.find((r) => r.id === id)?.badge || "bg-slate-500/10 text-slate-700 border-slate-300";
export const CONDIZIONI = [
  { id: "nuovo", label: "Nuovo" },
  { id: "rigenerato", label: "Rigenerato" },
  { id: "usato", label: "Usato" },
];


export const ENEL_OPERAZIONI = [
  { id: "swa", label: "SWA – Switch da altro operatore" },
  { id: "voltura", label: "Voltura" },
  { id: "voltura_swa", label: "Voltura con switch (VSA/SWA)" },
  { id: "subentro", label: "Subentro" },
  { id: "allaccio", label: "Allaccio" },
  { id: "prima_attivazione", label: "Prima attivazione" },
  { id: "altro", label: "Altro" },
];
export const enelOperazioneLabel = (id) => ENEL_OPERAZIONI.find((o) => o.id === id)?.label || id || "";



export const TIPO_CLIENTE = {
  privato: { label: "Privato", badge: "bg-slate-500/10 text-slate-600 border-slate-300" },
  ditta_individuale: { label: "Ditta individuale", badge: "bg-orange-500/15 text-orange-700 border-orange-300" },
  societa: { label: "Società", badge: "bg-indigo-500/15 text-indigo-700 border-indigo-300" },
};
export const tipoClienteInfo = (t) => TIPO_CLIENTE[t === "business" ? "societa" : (t || "privato")];
export const isBusinessCliente = (t) => !!t && t !== "privato";


export const PREMIUM_STEPS = {
  1: { label: "Step 1", badge: "bg-slate-500/15 text-slate-700 border-slate-300" },
  2: { label: "Step 2", badge: "bg-sky-500/15 text-sky-700 border-sky-300" },
  3: { label: "Premium", badge: "bg-amber-500/20 text-amber-800 border-amber-400" },
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
